import React from 'react';
const testimonials = [{
  text: 'Seguo 22 runner amatoriali tra 5K e maratona e ogni domenica perdevo mezza giornata a scrivere i programmi. Con la Elite Running Program Library scelgo il piano, lo adatto ai test dell\'atleta e in venti minuti ho la settimana pronta per tutti. Ho recuperato il weekend e i miei atleti ricevono un piano molto più curato.',
  author: 'Marco Rinaldi',
  role: 'Running Coach e preparatore atletico, 43 anni',
  location: 'Bologna, Italia'
}, {
  text: 'Il Session Builder è quello che uso ogni giorno: ho ripetute, soglia e VO₂max già strutturate con volumi e recuperi, così posso costruire il microciclo direttamente al campo mentre il gruppo si riscalda. Prima improvvisavo, adesso ogni allenamento ha un obiettivo preciso.',
  author: 'Giulia Ferraro',
  role: 'Coach di gruppo corsa e istruttrice atletica, 38 anni',
  location: 'Torino, Italia'
}, {
  text: 'Sono preparatore atletico e lavoro con runner che si infortunavano nei blocchi più intensi. Le schede di forza e prevenzione mi hanno permesso di inserire il lavoro complementare in modo sistematico: questa stagione ho avuto un solo stop contro i sei dell\'anno scorso.',
  author: 'Alessandro Bianchi',
  role: 'Preparatore atletico specializzato endurance, 50 anni',
  location: 'Verona, Italia'
}, {
  text: 'Le schede di valutazione e i report sui progressi sono stati una svolta commerciale: mostro all\'atleta i dati di soglia e volumi mese per mese e i rinnovi sono aumentati tantissimo. Finalmente ho un unico sistema invece di dodici fogli Excel.',
  author: 'Silvia Moretti',
  role: 'Titolare di studio di coaching per runner, 41 anni',
  location: 'Firenze, Italia'
}, {
  text: 'Ho iniziato da poco come coach e avevo paura di sbagliare la periodizzazione per la maratona. Con macrocicli, mesocicli e il planner gare ho portato i primi cinque atleti al personale, e il materiale pre-gara da consegnare mi ha fatto sembrare subito professionale.',
  author: 'Davide Colombo',
  role: 'Running Coach e Personal Trainer, 32 anni',
  location: 'Milano, Italia'
}];
export function Testimonials() {
  return <section className="py-6 px-4 sm:px-6 bg-white" data-id="element-132" data-mp="1oh2hcmfenedf">
      <h2 className="text-lg sm:text-3xl font-heading font-extrabold text-center text-navy leading-tight uppercase mb-4" data-id="element-133" data-mp="1ofrhgxp2yqrl">
        Cosa Dicono i Running Coach
      </h2>

      <div className="flex flex-col gap-2.5 max-w-3xl mx-auto" data-id="element-134" data-mp="1ejepq5d3imzh">
        {testimonials.map(t => <div key={t.author} className="bg-cream border border-gold/40 p-3.5 rounded-lg" data-id="element-135" data-mp="19rddgjfxgw9g">
            <p className="text-gold text-xs tracking-tighter mb-1" aria-label="5 su 5" data-id="element-136" data-mp="14tlb0vhnprr0">
              ⭐⭐⭐⭐⭐
            </p>
            <p className="text-anthracite text-[12.5px] sm:text-sm leading-relaxed italic mb-2.5" data-id="element-137" data-mp="vswx00s9jre4">
              "{t.text}"
            </p>
            <div className="flex items-center gap-2.5 border-t border-gold/30 pt-2" data-id="element-138" data-mp="quc4knj96c08">
              <div className="w-9 h-9 rounded-full bg-navy/10 border border-navy/20 flex items-center justify-center text-navy font-heading font-bold shrink-0" data-id="element-139" data-mp="32ge02whfctty">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-140" data-mp="3ccz71nd08f0f">
                <p className="font-heading font-bold text-navy text-[12.5px] sm:text-sm" data-id="element-141" data-mp="3ggylm0eq53r5">
                  {t.author}
                </p>
                <p className="text-[11px] text-anthracite" data-id="element-142" data-mp="2js92y7v9w744">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}